import { render, staticRenderFns } from "./HistoricalMedications.vue?vue&type=template&id=2fabb823&"
import script from "./HistoricalMedications.vue?vue&type=script&lang=ts&"
export * from "./HistoricalMedications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fabb823')) {
      api.createRecord('2fabb823', component.options)
    } else {
      api.reload('2fabb823', component.options)
    }
    module.hot.accept("./HistoricalMedications.vue?vue&type=template&id=2fabb823&", function () {
      api.rerender('2fabb823', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/admission/HistoricalMedications.vue"
export default component.exports